export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
export const FORM_NAME = 'relationship_settings';
export const REQUIRED_FIELDS = ['name', 'documents'];
export const DOCUMENTS_REQUIRED_FIELDS = ['key', 'name'];

export const TABLE_INFO_COLUMNS_NAMES = [{ dataIndex: 'label', width: 400 }, { dataIndex: 'value' }];
export const TABLE_INFO_NAME_COLUMNS_NAMES = [{ id: 'label', width: '375px' }, { id: 'value' }];

export const FIELDS_FOR_VALIDATE = ['name', 'documents[0].key', 'documents[0].name'];
